import React from 'react';
import {
  Heading1,
  Heading2,
  Paragraph,
  Bold,
} from '../../components/typography';
import { Container, Row, Col } from '../../components/grid';
import { Image } from '../../components/Image';
import { ItemTraverser } from '../../containers/commerce';
import { ScreenSizeDetector } from '../../lib/helpers';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import RowProductView from '../../components/grid/RowProductView';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';

export default () => (
  <SidemenuLayout menuPicker="Kildevand" activeSidemenu="DeniceVand">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Denice Kildevand - Kildevand til den prisbevidste</Heading1>
        </Col>
        <Col xs={12} md={2} textCenter>
          <ScreenSizeDetector imageHeight={[[767, '200px'], '225x']}>
            <Image name="oel-vand.denice-kildevand.png" alt="Denice kildevand plastikflaske 50cl B-pant" title="50cl Denice kildevand i pant plastik flaske" />
          </ScreenSizeDetector>
        </Col>
        <Col xs={12} md={10}>
          <Paragraph>
            <Bold>Type:</Bold><br />
            Naturligt Mineralvand
          </Paragraph>
          <Paragraph>
            <Bold>Størrelse:</Bold><br />
            50cl
          </Paragraph>
          <Paragraph>
            Denice Kildevand er vores billigste kildevand.
            Dette går dog ikke ud over kvaliteten af kildevanden som bliver produceret af Aquad&apos;or og kommer fra samme område ved Brande som firmaets øvrige produkter.
            Den eneste forskel er, at Aquad&apos;or har valgt ikke at markedsføre Denice, hvilket gør den billigere end de øvrige kildevand.
          </Paragraph>
          <Paragraph>
            Denice Kildevand fås i en let 50 cl plastikflaske og kan købes kassevis eller pallevis.
            Ved køb i paller fås en markant prisreduktion, hvilket gør Denice ideel til storindkøb af kildevand. Holdbarhed minimum 9-12 måneder.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="kildevandDenice" display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>Denice kildevand er med hårheden 6 blødt vand</Heading2>
          <Paragraph fontSize="12px">
            Hårhedsskalaen er 0-4 meget blødt, 4-8 blødt,
            8-12 middelhårdt, 12-18 temmelig hårdt, 18-24 hårdt,
            24-30 meget hårdt, 30- særdeles hårdt.
          </Paragraph>
        </Col>
        <Col xs={12} sm={6}>
          <Paragraph><Bold>Tekst på etikettens forside:</Bold></Paragraph>
          <Paragraph>
            Denice<br />
            0,5 liter<br />
            Naturligt mineralvand
          </Paragraph>
          <Paragraph><Bold>Tekst på etikettens bagside:</Bold></Paragraph>
          <Paragraph>
            Naturligt mineralvand fra Denice kilden på den jyske hede,<br />
            Egnet til natruimfattig kost. Nettoindhold 0,5 liter.<br />
            Opbevaring: Ved stuetemperatur (20-25 c) eller lavere.<br />
            Nydes afkølet.<br />
            Holdbar til: Se datomærkning på flasken
          </Paragraph>
        </Col>
        <Col xs={12} sm={6}>
          <Paragraph>
            <Bold>Analystisk sammensætning (mg/l)</Bold><br />
            Hydrogencarbonat 140<br />
            Sulfat 3<br />
            Klorid 11<br />
            Magnesium 15<br />
            Natrium 10<br />
            Nitrat &lt;0,5<br />
            Kalcium 22<br />
            Tørstof 145<br />
            Hårhed 6<br />
            pH 7,6
          </Paragraph>
          <Paragraph fontSize="12px">
            Produceret af<br />
            Aqua d&apos;or mineral water A/S<br />
            7330 Brande, Danmark, Tel: 96 29 12 00<br />
            www.aquador.com
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
